import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({ className = "", testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        data-testid={testid}
        {...props}
        className={`pr-12 ${className}`}
      />
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        aria-label={show ? "Sembunyikan isi kolom" : "Tampilkan isi kolom"}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 transition-colors duration-200 hover:text-[#1479BF]"
      >
        {show ? (
          <EyeOff aria-hidden="true" className="h-5 w-5" />
        ) : (
          <Eye aria-hidden="true" className="h-5 w-5" />
        )}
      </button>
    </div>
  );
}
